export enum MessageRole {
    User = 'USER',
    System = 'SYSTEM',
    Assistant = 'ASSISTANT',
}
